import React, { Component } from "react";
import {
  AutoSizer,
  List,
  CellMeasurer,
  CellMeasurerCache
} from "react-virtualized";
import { MenuItem } from "./TabSelectMenuGridPane";

interface TabSelectMenuListPaneProps {
  searchValue: string;
  maxListHeight: number;
  menuItems: MenuItem[];
  activeRowIndex: number;
}

interface TabSelectMenuListPaneState {
  listHeight: number;
}

interface IReactVirtualized {
  forceUpdateGrid: () => void;
  Grid: {
    getTotalRowsHeight: () => number;
  };
}

export class TabSelectMenuListPane extends Component<
  TabSelectMenuListPaneProps,
  TabSelectMenuListPaneState
> {
  listRef: React.RefObject<IReactVirtualized> | null;
  cache: any;

  static defaultProps = {
    maxListHeight: 390
  };

  constructor(props: TabSelectMenuListPaneProps) {
    super(props);
    this.listRef = React.createRef<IReactVirtualized>();
    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      fixedHeight: false,
      // HACK: window.innerHeight + 1 is a hack force is to do initial calculation as if there is a scroll bar
      // https://github.com/bvaughn/react-virtualized/issues/401#issuecomment-523090714
      defaultHeight: window.innerHeight + 1
    });
    this.renderRow = this.renderRow.bind(this);
    this.state = {
      listHeight: this.getTotalHeight()
    };
  }

  getTotalHeight() {
    let totalRowsHeight = this.listRef?.current?.Grid.getTotalRowsHeight();
    if (typeof totalRowsHeight !== "number") totalRowsHeight = -1;
    const listHeight = Math.min(totalRowsHeight, this.props.maxListHeight);
    return listHeight === -1 ? this.props.maxListHeight : listHeight;
  }

  componentDidUpdate() {
    const listHeight = this.getTotalHeight();
    if (listHeight !== this.state.listHeight) {
      this.setState({ listHeight });
    }
  }

  renderRow({
    index,
    parent,
    key,
    style
  }: {
    index: any;
    parent: any;
    key: string;
    style: any;
  }) {
    return (
      <CellMeasurer
        cache={this.cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {this.props.menuItems[index].render({
          active: index === this.props.activeRowIndex,
          onClick: this.props.menuItems[index].onSelect,
          style,
          key
        })}
      </CellMeasurer>
    );
  }

  render() {
    return (
      <AutoSizer disableHeight>
        {({ width }: { width: number }) => (
          <List
            ref={this.listRef}
            width={width}
            height={this.state.listHeight}
            columnCount={0}
            rowCount={this.props.menuItems.length}
            rowHeight={this.cache.rowHeight}
            rowRenderer={this.renderRow}
            activeRowIndex={this.props.activeRowIndex}
            deferredMeasurementCache={this.cache}
            overscanRowCount={5}
            scrollToAlignment="start"
            scrollToIndex={this.props.activeRowIndex}
          />
        )}
      </AutoSizer>
    );
  }
}
